import { ref, watch } from "vue";
import { defineStore } from "pinia";

const LOCAL_STORAGE_KEY = "participant_timepoint_id";

export const useParticipantTimepointStore = defineStore(
  "participant_timepoint",
  () => {
    const participant_timepoint_id = ref(
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || null,
    );
    watch(participant_timepoint_id, (newParticipantTimepointId) => {
      if (newParticipantTimepointId === null) {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      } else {
        localStorage.setItem(LOCAL_STORAGE_KEY, newParticipantTimepointId);
      }
    });

    const reset = () => {
      participant_timepoint_id.value = null;
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    };

    return {
      participant_timepoint_id,
      reset,
    };
  },
);
